import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// material-ui
// import { useTheme } from '@mui/material/styles';
import {
    Box,

    // Button,
    // Checkbox,
    // Divider,
    FormControl,
    // FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    // IconButton,
    // InputAdornment,
    // InputLabel,
    // OutlinedInput,
    TextField,
    Typography,
    //   Typography,
    //   useMediaQuery,
    // TextField,
    // Typography,

    // useMediaQuery
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
// import Google from 'assets/images/icons/social-google.svg';
import AnimateButton from 'ui-component/extended/AnimateButton';
// import { Login } from 'API/Authentication/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import LoadingButton from "@mui/lab/LoadingButton";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ChangePassowrd } from 'API/Change_password/api';
import MainCard from 'ui-component/cards/MainCard';

// import { useTheme } from '@mui/system';
// import Google from 'assets/images/logos/microsoft.png';

// import { strengthColor, strengthIndicator } from 'utils/password-strength';
// import { Stack } from '@mui/system';

// assets
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const ChangePasswordForm = (props, { ...others }) => {
    // const theme = useTheme();
    const scriptedRef = useScriptRef();
    const [openAlert, setOpenAlert] = useState(false);
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('');[]
    const [IsLoading, setIsLoading] = useState(false)
    const [ViewPasswords, setViewPasswords] = useState('password')
    const [ViewConfirmPassword, setViewConfirmPassword] = useState('password')
    //   const theme = useTheme();

    //   const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));



    const handleAlertOpen = (message, type) => {
        setAlertMessage(message);
        setAlertType(type);
        setOpenAlert(true);
    };




    const handlePasswordVisibility = () => {
        if (ViewPasswords === 'password') {
            setViewPasswords('text')
        }
        else {
            setViewPasswords('password')
        }
    }

    const handleConfirmPasswordVisibility = () => {
        if (ViewConfirmPassword === 'password') {
            setViewConfirmPassword('text')
        }
        else {
            setViewConfirmPassword('password')
        }
    }

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
    };


    // const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    // const customization = useSelector((state) => state.customization);
    // const [showPassword, setShowPassword] = useState(false);
    // const [checked, setChecked] = useState(true);
    // const otpState={
    //   mobile:'none',
    //   email:'none'
    // }

    // const handleStateChange=(e)=>{
    //   if(e==='Otp'){
    //     setotpState({...otpState,mobile:'flex'})
    //     console.log(scriptedRef.current.valueOf("phone"));
    //   }
    //   else{
    //     setotpState({...otpState,email:'flex'})
    //   }
    // }


    // const [strength, setStrength] = useState(0);
    // const [level, setLevel] = useState();

    // const googleHandler = async () => {
    //   console.error('Register');
    // };

    // const handleClickShowPassword = () => {
    //   setShowPassword(!showPassword);
    // };

    // const handleMouseDownPassword = (event) => {
    //   event.preventDefault();
    // };

    // const changePassword = (value) => {
    //   const temp = strengthIndicator(value);
    //   setStrength(temp);
    //   setLevel(strengthColor(temp));
    // };

    // useEffect(() => {
    //   changePassword('123456');
    // }, []);

    return (
        <>

            <Grid container direction="column" justifyContent="center" spacing={4} >
                {/* <Grid item xs={12}>
          <AnimateButton>
            <Button
              variant="outlined"
              fullWidth
              onClick={googleHandler}
              size="large"
              sx={{
                color: 'grey.700',
                backgroundColor: theme.palette.grey[50],
                borderColor: theme.palette.grey[100]
              }}
            >
              <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
                <img src={Google} alt="google" width={16} height={16} style={{ marginRight: matchDownSM ? 8 : 16 }} />
              </Box>
              Sign up with Google
            </Button>
          </AnimateButton>
        </Grid> */}
                {/* <Grid item xs={12}>
          <Box sx={{ alignItems: 'center', display: 'flex' }}>
            <Divider sx={{ flexGrow: 1 }} orientation="horizontal" />
            <Button
              variant="outlined"
              sx={{
                cursor: 'unset',
                m: 2,
                py: 0.5,
                px: 7,
                borderColor: `${theme.palette.grey[100]} !important`,
                color: `${theme.palette.grey[900]}!important`,
                fontWeight: 500,
                borderRadius: `${customization.borderRadius}px`
              }}
              disableRipple
              disabled
            >
              OR
            </Button>
            <Divider sx={{ flexGrow: 1 }} orientation="horizontal" />
          </Box>
        </Grid> */}

            </Grid>

            <MainCard sx={{ borderRadius: "20px", border: "1px solid #D0D0D0 !important" }}>

                <Typography variant='h3'>Change Password</Typography>

                <Formik
                    initialValues={{
                        old_password: '',
                        new_password: '',
                        confirm_password: ''
                    }}
                    validationSchema={Yup.object().shape({
                        old_password: Yup.string().max(15, "Password must be maximum of 15 characters")
                            .min(8, "Password must be minimum of 8 characters")
                            .matches(
                                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*\-+_])[A-Za-z\d!@#$%^&*\-+_]{8,15}$/,
                                "The password must be 8-15 characters long, with at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*-+_)"
                            )
                            .required('Password is required'),
                        new_password: Yup.string()
                            .max(15, "Password must be maximum of 15 characters")
                            .min(8, "Password must be minimum of 8 characters")
                            .matches(
                                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*\-+_])[A-Za-z\d!@#$%^&*\-+_]{8,15}$/,
                                "The password must be 8-15 characters long, with at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*-+_)"
                            )
                            .required('Password is required'),

                        confirm_password: Yup.string()
                            .max(15, "Password must be maximum of 15 characters")
                            .min(8, "Password must be minimum of 8 characters")
                            .matches(
                                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*\-+_])[A-Za-z\d!@#$%^&*\-+_]{8,15}$/,
                                "The password must be 8-15 characters long, with at least one uppercase letter, one lowercase letter, one digit, and one special character (!@#$%^&*-+_)"
                            )

                            .required('Confirm password is required')
                    })}
                    onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                        try {
                            if (scriptedRef.current) {
                                setStatus({ success: true });
                                setSubmitting(false);
                                if (values.new_password !== values.confirm_password) {
                                    handleAlertOpen("New Password and Confirm Password do not match", "error");
                                    return;
                                }
                                else {

                                    ChangePassowrd(values, setIsLoading, handleAlertOpen)
                                }
                            }
                        } catch (err) {
                            console.error(err);
                            if (scriptedRef.current) {
                                setStatus({ success: false });
                                setErrors({ submit: err.message });
                                setSubmitting(false);
                            }
                        }
                    }}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values, isValid }) => (
                        <form noValidate onSubmit={handleSubmit} {...others} >
                            {/* <Grid container spacing={matchDownSM ? 0 : 2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  margin="normal"
                  name="fname"
                  type="text"
                  defaultValue=""
                  sx={{ ...theme.typography.customInput }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  margin="normal"
                  name="lname"
                  type="text"
                  defaultValue=""
                  sx={{ ...theme.typography.customInput }}
                />
              </Grid>
            </Grid> */}
                            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleAlertClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                                <Alert
                                    onClose={handleAlertClose}
                                    severity={alertType}
                                    variant="filled"
                                    sx={{ width: '100%' }}
                                >
                                    {alertMessage}
                                </Alert>
                            </Snackbar>
                            <FormControl fullWidth error={Boolean(touched.old_password && errors.old_password)} sx={{ marginTop: '25px', marginBottom: 3 }}>
                                {/* <InputLabel htmlFor="outlined-adornment-email-register">Mobile Number</InputLabel> */}
                                <TextField
                                    error={touched.old_password && errors.old_password}
                                    id="outlined-error"
                                    type="text"
                                    label='Old Password'
                                    value={values.old_password}
                                    size='medium'
                                    name="old_password"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": { borderColor: "#E2E8F0" }, // Default border color
                                            "&:hover fieldset": { borderColor: "grey" }, // On hover
                                            "&.Mui-focused fieldset": { borderColor: touched.password && errors.password ? "red" : "dodgerblue" }, // On focus
                                        },
                                    }}
                                    onBlur={handleBlur}
                                    onChange={(e) => setFieldValue('old_password', e.target.value)}
                                    inputProps={{}}
                                />
                                {touched.old_password && errors.old_password && (
                                    <FormHelperText error id="standard-weight-helper-text--register">
                                        {errors.old_password}
                                    </FormHelperText>
                                )}
                            </FormControl>

                            {/* <Stack direction='row'>
                <Box width='100%'>

                </Box>
                <Box width='100%' display='flex' flexDirection='row' alignItems='end' >
                  <div style={{width:'50%'}}></div>
                    <Button variant='text' size='medium' sx={{width:'50%',marginBlock:'3px'}} onClick={()=>handleStateChange('Otp')}>Send Otp</Button>
                </Box>
              </Stack> */}

                            <FormControl fullWidth error={Boolean(touched.new_password && errors.new_password)} sx={{ marginTop: '10px', marginBottom: 3 }}>
                                <TextField
                                    error={errors.new_password && touched.new_password}
                                    id="outlined-error"
                                    type={ViewPasswords}
                                    size='medium'
                                    value={values.new_password}
                                    name="new_password"
                                    label="New Password"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": { borderColor: "#E2E8F0" }, // Default border color
                                            "&:hover fieldset": { borderColor: "grey" }, // On hover
                                            "&.Mui-focused fieldset": { borderColor: touched.password && errors.password ? "red" : "dodgerblue" }, // On focus
                                        },
                                    }}
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 15) {

                                            handleChange(e);
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (

                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handlePasswordVisibility}
                                                    edge="end"
                                                >
                                                    {ViewPasswords === 'text' ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>

                                        ),
                                    }}
                                />
                                {touched.new_password && errors.new_password && (
                                    <FormHelperText error id="standard-weight-helper-text-password-register">
                                        {errors.new_password}
                                    </FormHelperText>
                                )}
                            </FormControl>

                            <FormControl fullWidth error={Boolean(touched.confirm_password && errors.confirm_password)} sx={{ marginTop: '10px', marginBottom: 3 }}>
                                <TextField
                                    error={errors.confirm_password && touched.confirm_password}
                                    id="outlined-error"
                                    type={ViewConfirmPassword}
                                    size='medium'
                                    value={values.confirm_password}
                                    name="confirm_password"
                                    label="Confirm Password"
                                    onBlur={handleBlur}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": { borderColor: "#E2E8F0" }, // Default border color
                                            "&:hover fieldset": { borderColor: "grey" }, // On hover
                                            "&.Mui-focused fieldset": { borderColor: touched.password && errors.password ? "red" : "dodgerblue" }, // On focus
                                        },
                                    }}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 15) {

                                            handleChange(e);
                                        }
                                    }}

                                    InputProps={{
                                        endAdornment: (

                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleConfirmPasswordVisibility}
                                                    edge="end"
                                                >
                                                    {ViewConfirmPassword === 'text' ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>

                                        ),
                                    }}
                                />
                                {touched.confirm_password && errors.confirm_password && (
                                    <FormHelperText error id="standard-weight-helper-text-password-register">
                                        {errors.confirm_password}
                                    </FormHelperText>
                                )}
                            </FormControl>



                            {/* <Stack direction='row'>
                <Box width={{xl:'100%',xs:'30%'}}>

                </Box>
                <Box width={{xl:'100%',xs:'70%'}} display='flex' flexDirection='row' alignItems='end' >
                  <div style={{width:'50%'}}></div>
                    <Button variant='text' size='small' sx={{width:'50%',marginBlock:'3px'}} onClick={()=>handleStateChange('email')}>Send Code</Button>
                </Box>
              </Stack> */}



                            {/* {strength !== 0 && (
              <FormControl fullWidth>
                <Box sx={{ mb: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <Box style={{ backgroundColor: level?.color }} sx={{ width: 85, height: 8, borderRadius: '7px' }} />
                    </Grid>
                    <Grid item>
                      <Typography variant="subtitle1" fontSize="0.75rem">
                        {level?.label}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </FormControl>
            )} */}

                            <Grid container alignItems="center" justifyContent="space-between" sx={{ height: '4vh' }}>
                                <Grid item>
                                    {/* <FormControlLabel
                  control={
                    <Checkbox checked={checked} onChange={(event) => setChecked(event.target.checked)} name="checked" color="primary" />
                  }
                  label={
                    <Typography variant="subtitle1">
                      Agree with &nbsp;
                      <Typography variant="subtitle1" component={Link} to="#">
                        Terms & Condition.
                      </Typography>
                    </Typography>
                  }
                /> */}
                                </Grid>
                            </Grid>
                            {errors.submit && (
                                <Box sx={{ mt: 3 }}>
                                    <FormHelperText error>{errors.submit}</FormHelperText>
                                </Box>
                            )}




                            <Box sx={{ mt: 1, textAlign: 'center' }}>
                                <Grid container gap={1} justifyContent='center'>
                                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <AnimateButton >
                                            <LoadingButton sx={{ borderRadius: '8px' }} disableElevation loading={IsLoading} onClick={handleSubmit} disabled={isSubmitting || !isValid} fullWidth size="medium" type="submit" variant="contained" color="secondary">
                                                SUBMIT
                                            </LoadingButton>
                                        </AnimateButton>
                                    </Grid>

                                </Grid>
                            </Box>
                        </form>
                    )}
                </Formik>
            </MainCard>
        </>
    );
};

export default ChangePasswordForm;
